export default angular
  .module('app.formatting', [])
  .name;

require('./filters/format-amount');
require('./filters/format-balance');
require('./filters/format-date');
require('./filters/format-date-time');
require('./filters/format-number');
require('./filters/format-percentage');
require('./filters/format-product');
require('./filters/format-product-rate');
require('./filters/format-weight');
require('./services/formatting');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/formatting/index.js